import { render, staticRenderFns } from "./addquestion.vue?vue&type=template&id=2db42b7b&scoped=true"
import script from "./addquestion.vue?vue&type=script&lang=js"
export * from "./addquestion.vue?vue&type=script&lang=js"
import style0 from "./addquestion.vue?vue&type=style&index=0&id=2db42b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db42b7b",
  null
  
)

export default component.exports